<template>
  <div class="pa-4 pa-md-5">
    <v-btn @click="$router.back()" class="back-btn mb-3">
      <v-icon left>mdi-arrow-left</v-icon>
      VOLVER
    </v-btn>

    <v-col cols="12" class="pa-0">
      <tabla
        Titulo="Tipo de Cambio"
        :Cabecera="Cabecera"
        :Items="Items"
        :Excel="true"
        :Crear="true"
        :Loading="Loading"
      />
    </v-col>
  </div>
</template>

<script>
import tabla from "@/components/tipocambio/tabla.vue";
import { mapGetters, mapActions, mapState } from "vuex";

export default {
  name: "TipoCambio",
  components: {
    tabla,
  },
  created() {
    const data = { menu: 1, submenu: 1 };
    this.CargarMenu(data);
    this.cargarTipoCambio();
  },
  data() {
    return {
      Cabecera: [
        { text: "Acciones", value: "acciones", align: "center", sortable: false, width: 90 },
        { text: "ID", value: "id", align: "center", width: 80 },
        { text: "Valor (S/)", value: "valor", align: "center" },
        { text: "Fecha", value: "fecha", align: "center" },
        { text: "Estado", value: "estado", align: "center", width: 130 },
      ],
    };
  },
  methods: {
    ...mapActions("tipocambio", ["cargarTipoCambio"]),
    ...mapActions("nav", ["CargarMenu"]),
  },
  computed: {
    ...mapGetters("tipocambio", ["Items"]),
    ...mapState("tipocambio", ["Loading"]),
  },
};
</script>
